exports.APIS = {
  //about us
  aboutbanner: "/website/aboutus/aboutbanner",
  count: "/website/aboutus/count",
  whoweare: "/website/aboutus/whoweare",
  whychoose: "/website/aboutus/whychoose",
  feedback: "/website/aboutus/feedback",
  faq: "/website/aboutus/faq",

  //parental counselling
  pbanner: "/website/parentalcounselling/parent_banner",
  what_counselling: "/website/parentalcounselling/what_counselling",
  how_counselling: "/website/parentalcounselling/how_counselling",
  who_should_opt: "/website/parentalcounselling/who_should_opt",

  //contain
  contact: "/website/contactus/contactus",
  termscondition: "/website/termsandcondition/termsandcondition",
  privacypolicy: "/website/privacypolicy/privacypolicy",
  counsellingform: "/website/counsellingform/counsellingform",
  appsetup: "/website/appsetup/appsetup",

  Auth: {
    sendLoginOtp: "/website/login/send-otp",
    LoginverifyOtp: "/website/login/verify-otp",
    getprofile: "/website/login/profile",
    updateprofile: "/website/login/update-profile",
    getAllReport: "/website/login/my-report",
  },

  Test: {
    AllTest: "/website/test/all-exam",
    startTest: "/website/test/start-test",
  },

  TestQuestion: {
    AllTestQuestion: "/website/test/all-exam-question",
    updateUserAnswer: "/website/test/update-user-answer",
    final_submit: "/website/test/final-submit",
  },

  AppSetup: {
    app_setup: "/website/appsetup/appsetup",
  },

  //Home Page
  HomePage: {
    HomeBanner: "/website/homepage/homebanner",
    OurGuidance: "/website/homepage/ourguidance",
    Moments: "/website/homepage/moments",
    HomeBlog: "/website/homepage/blog",
    PublishedBook: "/website/homepage/publishedbook",
  },

  //Blog page
  Blogs: {
    AllBlogs: "/website/blog/blog",
    Blog: "/website/blog/blog",
  },

  //Career Counselling
  CareerCounselling: {
    CareerBanner: "/website/careercounselling/careerbanner",
    WhatCareer: "/website/careercounselling/whatcareer",
    CareerProcess: "/website/careercounselling/careerprocess",
    WhoShouldOpt: "/website/careercounselling/whoshouldopt",
  },

  Commons: {
    AllTypes: "/website/homepage/alltypes",
    AllCountry: "/common/masters/all-country",
    AllState: "/common/masters/all-state",
    AllCity: "/common/masters/all-city",
    AllPincode: "/common/masters/all-pincode",
    AllHomeBanner: "/common/homepage/all-homebanner",
    AllOurGuidance: "/common/homepage/all-ourguidance",
    AllMoments: "/common/homepage/all-moments",
    AllBlog: "/common/blogs/all-blog",
    AllCareerBanner: "/common/careercounselling/all-careerbanner",
    AllWhatCareer: "/common/careercounselling/all-whatcareer",
    AllCareerProcess: "/common/careercounselling/all-careerprocess",
    AllWhoShouldOpt: "/common/careercounselling/all-whoshouldopt",
    AllPublishedBook: "/common/homepage/all-publishedbook",
  },
};
